import React, { useState, useEffect, useCallback } from 'react'
import './style.scss'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'
import { Icon } from 'react-icons-kit'
import { toast } from 'react-toastify'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { api } from '../../../../utils/api'
import { useForm } from 'react-hook-form'
import 'react-toastify/dist/ReactToastify.css'
import { chevronLeft } from 'react-icons-kit/feather'

const EditCommission = () => {
    const { register, handleSubmit, setValue, formState: { errors } } = useForm()
    const { id } = useParams()

    const navigate = useNavigate()
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    const { mutate, isLoading } = useMutation({
        mutationFn: async (data) => {
            const res = await axios.put(`${api}ghotok/comission/${id}/edit`, data, header)
            return res.data
        },
        onSuccess: (data) => {
            toast.success(data.message || "Commission updated successfully.")
            navigate('/dashboard/agents/comission');
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to update commission.")
        }
    });

    useEffect(() => {
        const fetchCommissionData = async () => {
            try {
                const response = await axios.get(`${api}ghotok/comission/index`, header)
                if (response.data && response.data.percentageList) {
                    const showData = response.data.percentageList.find((obj) => obj._id === id);
                    if (showData) {
                        setValue('percentage', showData.percentage)
                        setValue('description', showData.description)
                    }
                }
            } catch (error) {
                toast.error("Failed to fetch commission data.")
            }
        }
        fetchCommissionData()
    }, [id, header, setValue])

    // Submit Form
    const onSubmit = (data) => {
        mutate(data)
    }

    return (
        <div className="create-membership-package">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding mb-2">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header bg-white p-md-4">
                                <div className="d-flex">
                                    <div><h5 className="mt-2 mb-0">Edit Commission</h5></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/agents/comission"
                                            type="button"
                                            className="btn shadow-none back-btn"
                                        ><Icon icon={chevronLeft} size={18} />Back</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-md-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">

                                        {/* Commission */}
                                        <div className="col-12">
                                            <div className="col-lg-6">
                                                <div className="form-group mb-4">
                                                    {errors.percentage ? (
                                                        <p className="text-danger">{errors.percentage.message}</p>
                                                    ) : <p>Commission (%)</p>}

                                                    <input
                                                        type="number"
                                                        placeholder="Enter Commission Percentage"
                                                        className={errors.percentage ? "form-control shadow-none error" : "form-control shadow-none"}
                                                        {...register("percentage", {
                                                            required: "Percentage is required",
                                                            valueAsNumber: true,
                                                            min: { value: 0, message: "Percentage can't be negative" },
                                                            max: { value: 100, message: "Percentage can't be more than 100" }
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Description */}
                                        <div className="col-12">
                                            <div className="col-lg-6">
                                                <div className="form-group mb-4">
                                                    {errors.description ? (
                                                        <p className="text-danger">{errors.description.message}</p>
                                                    ) : <p>Description</p>}

                                                    <textarea
                                                        rows={5}
                                                        className="form-control shadow-none"
                                                        placeholder="Write description"
                                                        {...register("description", { required: "Description is required" })}
                                                    />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-12 col-lg-6 text-end">
                                            <br />
                                            <button type="submit" className="btn shadow-none text-white" disabled={isLoading}>{isLoading ? 'Updating...' : 'Update'}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default EditCommission;